module.exports = __webpack_public_path__ + "img/fm.2d1657d1.svg";